module.exports = __webpack_public_path__ + "img/logo-controlboard.b1007745.png";